export default __webpack_public_path__ + "static/media/iossettings2.396c7339.png";